$( document ).ready(function() {
  try {
    //$('.toolbar__content').appendTo('.announcement-bar .slideshow-wrapper');
    $('.select_language .disclosure__toggle').on('click', function(){
        $('.select_language ul.disclosure-list').toggleClass('active');
    });
    $(".grid-product__colors > a.color-swatch").mouseenter(function() {
            var img_url = $(this).attr('data-variant-image');
            //console.log(img_url);
            $(this).addClass('active');
            if( $(this).hasClass('active') ){
                // $('.grid-product__color-image.large').addClass('active');
                $(this).parent().prev().find('.grid-product__color-image.large').addClass('active');
                $(".grid-product__color-image.large.active").css("background-image", "url(" + img_url + ")"); 
            }else{
                $('.grid-product__color-image.large').removeClass('active');
                $(".grid-product__color-image.large").css("background-image", "inherit"); 
            }
        }).mouseleave(function() {
            $(this).removeClass('active');
            $('.grid-product__color-image.large').removeClass('active');
            $('.grid-product__color-image.large').css("background-image", "inherit"); 
    });

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
    document.body.appendChild(script);
    script.onload = function(){
        $('.slider_related_product').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true,
            auto: true,
            autoplaySpeed: 6000,
            speed: 300,
            pauseOnHover: true,
            responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                  }
              },
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                  }
              }
            ]
      });
    };
    
    // Slider of related product
    
  } catch (error) {
    console.log(error, 'error')
  }
    
});
